/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BlockIcon20Light = forwardRef('BlockIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 2a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM5.27 4.564a6.5 6.5 0 0 1 9.165 9.165L5.272 4.564Zm-.706.707a6.5 6.5 0 0 0 9.165 9.165L4.564 5.271Z" })));
});
